///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import Tippy from "@tippyjs/react";

export const Tooltip = props => (
  <Tippy
    arrow={true}
    className="tooltip"
    delay={0}
    duration={0}
    placement="right-start"
    offset={[-2, 8]}
    touch="hold"
    {...props}
  />
);

export default Tooltip;
